import React from 'react';
import { Link } from 'react-router-dom';
import logoFull from '../../assets/LogoAC.webp';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-main">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src={logoFull} alt="AeroCapture Productions" className="footer-logo-img" />
            </Link>
            <p className="footer-description">
              Web development, media production, and software solutions.
            </p>
            <div className="footer-contact">
              <a href="mailto:ivargavelin@gmail.com">ivargavelin@gmail.com</a>
              <span>Stockholm, Sweden</span>
            </div>
          </div>

          <nav className="footer-nav">
            <div className="footer-nav-group">
              <h4 className="footer-nav-title">Navigation</h4>
              <Link to="/">Home</Link>
              <Link to="/products">Products</Link>
              <Link to="/projects">Projects</Link>
              <Link to="/contact">Contact</Link>
            </div>

            <div className="footer-nav-group">
              <h4 className="footer-nav-title">Products</h4>
              <Link to="/products/mandatum">Mandatum</Link>
              <Link to="/products/wopr">WOPR</Link>
              <Link to="/products/idleveil">Idleveil</Link>
            </div>

            <div className="footer-nav-group">
              <h4 className="footer-nav-title">Connect</h4>
              <a href="https://www.linkedin.com/company/aerocapture-productions-ekonomisk-f%C3%B6rening/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
              <a href="https://github.com/Ivargavve" target="_blank" rel="noopener noreferrer">GitHub</a>
              <a href="https://www.youtube.com/@aerocapturep" target="_blank" rel="noopener noreferrer">YouTube</a>
              <a href="https://www.instagram.com/aerocaptureproduction/" target="_blank" rel="noopener noreferrer">Instagram</a>
            </div>
          </nav>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 AeroCapture Productions. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
